export default __webpack_public_path__ + "static/media/no-image.dc4292b7.png";